<fieldset ngModelGroup="anexos">
  <legend [class.invalid]='isTamanhoMaximoAnexoExcedido()'>Anexos Planejamento:</legend>

  <!-- Campo para invalidar o formulário em caso de anexos excedidos -->
  <div *ngIf="dadostela?.tamanhoMaximoAnexoExcedido" >
    <input name="tamanhoMaximoAnexoExcedido" id="tamanhoMaximoAnexoExcedido" 
           [hidden]="true" ngModel matInput required>
  </div>

  <div style="padding-top: .5rem">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap=".5rem">

      <input-file class="upload" 
                  label="SELECIONE OS ARQUIVOS PARA ENVIAR"
                  [extensoesAceitas]="getExtensoesPermitidasAnexos()" 
                  [multiplosArquivos]="true" 
                  cor="warn"
                  (selecionado)="selecionarAnexos($event)">
      </input-file>

      <button mat-icon-button (click)="exibirTamanhoAnexos()">
        <mat-icon fontIcon="info" 
                  color="warn" 
                  matTooltip="Clique para ver os tipos e tamanhos dos arquivos permitidos"
                  matTooltipPosition="above">
        </mat-icon>
      </button>
    </div>
  </div>


  <div *ngIf="dadostela.anexos?.length > 0">
    <barra-porcentagem [parcial]="somaAnexos" [total]="somaMaximaAnexos"></barra-porcentagem>
    Total de arquivos anexados: {{ dadostela.anexos.length }}

      <table mat-table #tabelaAnexos matSort matSortDisableClear [dataSource]="dataSource" >

        <!-- Coluna: Descrição -->
        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrição </th>
          <td mat-cell *matCellDef="let elm;  let i = index">
            <mat-form-field style="margin-top: 10px; width: 90%;">
              <input matInput [(ngModel)]="elm.metadados.nmArquivo" placeholder="Descrição" [value]="elm.metadados.nmArquivo"
                name="descricao_{{i}}" maxlength="100" required>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Coluna: Extensão -->
        <ng-container matColumnDef="extensao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo Arquivo </th>
          <td mat-cell *matCellDef="let elm">
            {{ elm.metadados.dsTipoArquivo }}
          </td>
        </ng-container>

        <!-- Coluna: Tamanho -->
        <ng-container matColumnDef="tamanho">
          <th mat-header-cell *matHeaderCellDef> Tamanho </th>
          <td mat-cell *matCellDef="let elm">
            {{elm.metadados.nrTamanhoArquivo | bytes}}
          </td>
        </ng-container>

        <!-- Coluna: Visualizar -->
        <ng-container matColumnDef="visualizar">
          <th mat-header-cell *matHeaderCellDef >
          </th>
          <td mat-cell *matCellDef="let elm; let i = index">
            <visualizar-arquivo [dados]="getArquivoMinuta(elm)"></visualizar-arquivo>
          </td>
        </ng-container>

        <!-- Coluna: Alterar -->
        <ng-container matColumnDef="alterar">
          <th mat-header-cell *matHeaderCellDef>
          </th>
          <td mat-cell *matCellDef="let elm; let i = index">
            <input-file matTooltip="Substituir este anexo" matTooltipPosition="above"
              [extensoesAceitas]="getExtensoesPermitidasAnexos()" [multiplosArquivos]="false"
              (selecionado)="alterarAnexo($event[0], i)">
            </input-file>
          </td>
        </ng-container>

        <!-- Coluna: Excluir -->
        <ng-container matColumnDef="excluir">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button (click)="excluirTodos()" matTooltip="Excluir todos os anexos"
              matTooltipPosition="above">
              <mat-icon>delete</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let elm">
            <button mat-icon-button (click)="excluirAnexo(elm)" matTooltip="Excluir este anexo"
              matTooltipPosition="above">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunasVisiveis"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasVisiveis;"></tr>
      </table>
    </div>

</fieldset>
